
import { computed, defineComponent, PropType } from 'vue'
import type { UxPagePricing } from '@/helpers/marketplace/uxSettings'

export default defineComponent({
    props: {
        pricing: {
            type: Object as PropType<UxPagePricing>,
            required: true,
        },
    },
    setup(props) {
        const shouldShowBestFlag = computed(() => {
            if (!props.pricing || props.pricing.type !== 'tiers') return false
            return props.pricing.showBestFlag !== false
        })

        const isBestRow = (index: number) => {
            if (!props.pricing || props.pricing.type !== 'tiers') return false
            if (typeof props.pricing.bestRowIndex === 'number') {
                return index === props.pricing.bestRowIndex
            }
            return !!props.pricing.flagLast && index === props.pricing.rows.length - 1
        }

        const headerLabel = computed(() => {
            if (!props.pricing || props.pricing.type !== 'tiers') return ''
            return props.pricing.header || ''
        })

        const splitCell = (value: string) => String(value || '').split('\n').filter(Boolean)

        return { headerLabel, splitCell, isBestRow, shouldShowBestFlag }
    },
})
